import CancelIcon from '@mui/icons-material/Cancel';
import IconeApregoar from '@mui/icons-material/Cast';
import IconeApregoado from '@mui/icons-material/CastConnected';
import WarningIcon from '@mui/icons-material/Warning';
import {
    Box,
    Button,
    Checkbox,
    ClickAwayListener,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControlLabel,
    FormGroup,
    List,
    ListItemButton,
    Paper,
    Popper,
    Tooltip,
    Typography
} from '@mui/material';
import { red } from '@mui/material/colors';
import { action, computed, makeObservable, observable, runInAction, toJS } from 'mobx';
import { inject, observer } from 'mobx-react';
import ReactComponent from '../ReactComponent';

class ApregoarPlanilha extends ReactComponent {
    abrirPopover = false;
    dialogOpen = false;
    opcaoSelecionada;
    marcarAdvAusentes = !!this.isComponenteHabilitado('MarcarAdvogadosAusentesNoPregaoPlanilha');

    handleClickIconeApregoar = (event) => {
        if (!this.acabouDeFechar) {
            this.abrirPopover = true;
            this.anchorEl = event.currentTarget;
        }
    };

    handleClosePopper = () => {
        this.acabouDeFechar = true;
        setTimeout(() => {
            runInAction(() => {
                this.acabouDeFechar = false;
            });
        }, 10);
        this.abrirPopover = false;
        this.anchorEl = null;
    };

    constructor(props) {
        super(props);

        makeObservable(this, {
            abrirPopover: observable,
            dialogOpen: observable,
            opcaoSelecionada: observable,
            marcarAdvAusentes: observable,
            handleClickIconeApregoar: action,
            handleClosePopper: action,
            opcoesRelatores: computed,
            handleClickRelator: action,
            handleClickBotaoApregoar: action,
            handleCloseDialog: action,
            handleChangeAdvAusentes: action,
            relatorSelecionado: computed,
            processosApregoaveisNaoApreciadosComAdvNaoAusenteDoRelatorSelecionado: computed
        });
    }

    get opcoesRelatores() {
        return this.salaSessaoStore.opcoesRelatoresApregoamento;
    }

    handleClickRelator = (opcaoRelator) => {
        this.opcaoSelecionada = opcaoRelator;
        this.handleClosePopper();
        this.dialogOpen = true;
    };

    async handleClickBotaoApregoar(opcaoSelecionada) {
        if (opcaoSelecionada.qtdPendentes > 0) {
            this.store.alterandoValorFiltro = true;

            this.setTimeout(() => {
                this.salaSessaoStore.filtros.filtroNomeRelator.valor = [opcaoSelecionada.value];
                this.salaSessaoStore.filtros.filtroRetornoVistaRegimental.valor = false;
                this.store.alterandoValorFiltro = false;
            });

            const relator = this.salaSessaoStore.getRelator(opcaoSelecionada.value);
            let inscricoes = undefined;

            if (this.marcarAdvAusentes) {
                const inscricoesEncontradas =
                    this.salaSessaoStore.findInscricoesAdvogadosNaoAusentesDeProcessosNaoApreciados(
                        relator.sigla,
                        true
                    );

                inscricoes = toJS(inscricoesEncontradas); // Armazena uma cópia para viabilizar o envio para o servidor após a marcação local
            }

            this.sessaoStore.processoApregoado = undefined;
            this.sessaoService.apregoarPlanilha(
                this.sessaoStore.sessaoSelecionada.sessoes[0].id,
                relator,
                this.marcarAdvAusentes,
                opcaoSelecionada.qtdPendentes
            );

            if (this.marcarAdvAusentes && inscricoes !== undefined) {
                this.salaSessaoStore.marcarAdvogadosAusentes(inscricoes, false, true, false); // Requsições executadas pelo backend
                //this.salaSessaoStore.marcarAdvogadosAusentesEmLoteUmAUm(inscricoes, false, true, false); // Requsições executadas pelo frontend
            }

            this.abrirPopover = false;
            this.sessaoStore.sessaoSelecionada.processos.forEach((registro) => {
                if (registro.processo.numeroCompleto === opcaoSelecionada.primeiroProcesso) {
                    this.salaSessaoStore.processoExpandido = registro;
                }
            });

            this.handleCloseDialog();
        } else {
            this.mensagemStore.abrirMensagemAlerta(
                `Não há processos pendentes para o relator ${opcaoSelecionada.label}`
            );
        }
    }

    handleCloseDialog = () => {
        this.opcaoSelecionada = undefined;
        this.dialogOpen = false;
    };

    // [REVIEW] Usar "React.createRef()"?
    elementoIconeApregoar = () => {
        const nomeElemento = 'iconeApregoar';
        const elemento = document.getElementById(nomeElemento);

        if (elemento !== null) {
            return elemento;
        } else {
            console.warn(`Elemento "${nomeElemento}" não encontrado.`);
            return null;
        }
    };

    handleChangeAdvAusentes = (event) => {
        this.marcarAdvAusentes = event.target.checked;
    };

    get relatorSelecionado() {
        if (!this.opcaoSelecionada?.value) {
            return null;
        }

        return this.salaSessaoStore.getRelator(this.opcaoSelecionada.value);
    }

    /** @type {Object[]} */
    get processosApregoaveisNaoApreciadosComAdvNaoAusenteDoRelatorSelecionado() {
        if (!this.relatorSelecionado?.sigla) {
            return [];
        }

        return this.salaSessaoStore.findProcessosNaoApreciadosComAdvogadosNaoAusentes(
            this.relatorSelecionado.sigla,
            true
        );
    }

    renderAdvogadosNaoAusentes() {
        if (!this.opcaoSelecionada?.qtdPendentes) {
            return null;
        }

        const total = this.processosApregoaveisNaoApreciadosComAdvNaoAusenteDoRelatorSelecionado.length;

        if (!total) {
            return null;
        }

        const plural = total > 1 ? 's' : '';

        return (
            <Box sx={{ mt: 3, ml: 2 }}>
                <WarningIcon sx={{ verticalAlign: 'middle', color: 'orange' }} />
                <Typography
                    display={'inline'}
                    sx={{ ml: 2 }}
                >
                    ATENÇÃO: Há <b>{String(total).padStart(2, '0')}</b> processo{plural} pendente{plural} com pelo menos
                    1 advogado não marcado como ausente.
                </Typography>
                {this.isComponenteHabilitado('MarcarAdvogadosAusentesNoPregaoPlanilha') && (
                    <Box sx={{ mt: 1 }}>
                        <FormGroup>
                            <FormControlLabel
                                control={<Checkbox checked={this.marcarAdvAusentes} />}
                                onChange={this.handleChangeAdvAusentes}
                                label="Marcar advogados dos processos pendentes como ausentes e derrubar esses processos das preferências para planilha, com exceção de vistas regimentais."
                            />
                        </FormGroup>
                    </Box>
                )}
            </Box>
        );
    }

    render() {
        return (
            <>
                <Tooltip
                    title={'Apregoar planilha'}
                    placement="top-start"
                    className="corBotao"
                >
                    <Box
                        id="iconeApregoar"
                        style={{ marginRight: '10px' }}
                        onClick={this.handleClickIconeApregoar}
                    >
                        {this.sessaoStore.relatorPregaoLote ? (
                            <IconeApregoado style={{ cursor: 'pointer' }} />
                        ) : (
                            <IconeApregoar style={{ cursor: 'pointer' }} />
                        )}
                    </Box>
                </Tooltip>
                {this.abrirPopover && (
                    <Popper
                        onClick={(event) => event.preventDefault()}
                        open={this.abrirPopover}
                        anchorEl={this.elementoIconeApregoar}
                        placement="bottom-start"
                        style={{ zIndex: '99' }}
                    >
                        <ClickAwayListener onClickAway={this.handleClosePopper}>
                            <Paper>
                                <Typography
                                    variant="subtitle1"
                                    style={{ padding: '5px 15px 5px 15px', fontWeight: 'bold' }}
                                >
                                    Apregoar planilha
                                </Typography>
                                {this.opcoesRelatores.length > 0 ? (
                                    <List>
                                        {this.opcoesRelatores.map((opcaoRelator) => (
                                            <ListItemButton
                                                key={opcaoRelator.label}
                                                onClick={() => this.handleClickRelator(opcaoRelator)}
                                                style={{
                                                    color:
                                                        opcaoRelator.value === this.sessaoStore.relatorPregaoLote
                                                            ? red[900]
                                                            : 'black',
                                                    display: 'flex',
                                                    alignItems: 'center'
                                                }}
                                            >
                                                <b>{opcaoRelator.label}</b>
                                                <Typography sx={{ ml: 0.5, fontSize: '11pt' }}>
                                                    {'(Pendentes: ' +
                                                        opcaoRelator.qtdPendentes +
                                                        (opcaoRelator.qtdPendentes > 1
                                                            ? ' / Primeiro: ' +
                                                              opcaoRelator.primeiroProcesso +
                                                              ' / Último: ' +
                                                              opcaoRelator.ultimoProcesso
                                                            : ' / Processo: ' + opcaoRelator.primeiroProcesso) +
                                                        ')'}
                                                </Typography>
                                            </ListItemButton>
                                        ))}
                                    </List>
                                ) : (
                                    <Typography style={{ padding: '4px 16px 4px 16px' }}>
                                        Não há processos pendentes em condições de apregoamento em lote
                                    </Typography>
                                )}
                            </Paper>
                        </ClickAwayListener>
                    </Popper>
                )}
                {this.opcaoSelecionada && this.dialogOpen && (
                    <Dialog
                        maxWidth="lg"
                        onClose={this.handleCloseDialog}
                        open={this.dialogOpen}
                    >
                        <DialogTitle
                            id="dialog-title-pregao-de-planilha"
                            sx={{ pb: 0 }}
                        >
                            <Typography>Apregoar planilha de processos pendentes do relator:</Typography>
                            <Typography sx={{ fontWeight: 'bold' }}>{this.opcaoSelecionada.label}?</Typography>
                        </DialogTitle>
                        <DialogContent>
                            <Box sx={{ mt: 3, ml: 2 }}>
                                <Typography display={'inline'}>Quantidade de processos:</Typography>
                                <Typography
                                    display={'inline'}
                                    sx={{ ml: 1, fontWeight: 'bold' }}
                                >
                                    {String(
                                        this.opcaoSelecionada?.qtdPendentes ? this.opcaoSelecionada.qtdPendentes : 0
                                    ).padStart(2, '0')}
                                </Typography>
                            </Box>
                            {this.opcaoSelecionada.qtdPendentes === 1 && (
                                <Box sx={{ mt: 3, ml: 2 }}>
                                    <Typography>{`Processo: ${this.opcaoSelecionada.primeiroProcesso}`}</Typography>
                                </Box>
                            )}
                            {this.opcaoSelecionada.qtdPendentes > 1 && (
                                <Box sx={{ mt: 3, ml: 2 }}>
                                    <Typography>
                                        {`Primeiro processo: ${this.opcaoSelecionada.primeiroProcesso}`}
                                    </Typography>
                                    <Typography sx={{ mt: 1 }}>
                                        {`Último processo: ${this.opcaoSelecionada.ultimoProcesso}`}
                                    </Typography>
                                </Box>
                            )}
                            {this.renderAdvogadosNaoAusentes()}
                        </DialogContent>
                        <DialogActions sx={{ m: 1 }}>
                            <Button
                                onClick={this.handleCloseDialog}
                                color="secondary"
                                variant="outlined"
                                endIcon={<CancelIcon />}
                                sx={{ mr: 1 }}
                            >
                                Cancelar
                            </Button>
                            <Button
                                onClick={() => this.handleClickBotaoApregoar(this.opcaoSelecionada)}
                                color="primary"
                                variant="contained"
                                endIcon={<IconeApregoar />}
                                sx={{ mr: 1 }}
                            >
                                Apregoar planilha
                            </Button>
                        </DialogActions>
                    </Dialog>
                )}
            </>
        );
    }
}

export default inject('stores')(observer(ApregoarPlanilha));
